import { render } from "./TaxResidenceField.vue?vue&type=template&id=98d63872&scoped=true&ts=true"
import script from "./TaxResidenceField.vue?vue&type=script&lang=ts"
export * from "./TaxResidenceField.vue?vue&type=script&lang=ts"

import "./TaxResidenceField.vue?vue&type=style&index=0&id=98d63872&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-98d63872"]])

export default __exports__